/* import __COLOCATED_TEMPLATE__ from './company-profile-assets.hbs'; */
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Component from '@ember/component';
import AssetUploadManager from '../../mixins/asset-upload-manager';

const CLASS_NAME = 'SH-c-company-profile-assets';

export default Component.extend(AssetUploadManager, {
  /** @inheritDoc */
  tagName: 'div',
  classNames: [CLASS_NAME],
  CLASS_NAME,

  /** Register services */
  applicationStateManager: service('state-managers/application'),
  companyCommandService : service('commands/company-commands'),

  /** @param {Company|null} company */
  company: null,

  /** @param {Boolean} hasAdminOrCompanyAdminPermission */
  hasAdminOrCompanyAdminPermission: false,

  /** @param {Function} */
  deleteAsset: () => {},

  onAssetFinalized: action(function(uploadID) {
    const asset = this.get(`uploads.${uploadID}.asset`);
    const filename = this.get(`uploads.${uploadID}.filename`);

    this.companyCommandService
      .attachAssetToCompany(this.company, asset)
      .then(() => this.applicationStateManager.addToast(`Added ${filename}`))
      .catch(() => this.applicationStateManager.addToast(`Failed to add ${filename}`))
      .finally(() => this.removeFile(uploadID));
  }),

  actions: {
    /**
     * Deletes an asset from the company.
     *
     * @param {Asset} asset
     */
    deleteAsset(asset) {
      this.get('deleteAsset')(asset);
    },

    /**
     * Called when the file input component receives new files.
     *
     * @param {FileList} files The files selected via the file input button.
     */
    onFileInputChange(files) {
      this.addFiles(files);
    },

    /**
     * Called when an asset's delete button is clicked.
     *
     * @param {String} uploadID
     */
    onClickDeleteAssetButton(uploadID) {
      this.removeFile(uploadID);
    },
  }
});
